<svg viewBox="0 0 147.3 59.8">
	<polygon
		class="pattern_st0"
		points="120.9,19.9 56.9,19.9 65.2,0 129.2,0 120.9,19.9 "
	/>
	<polygon class="pattern_st0" points="147.3,19.9 147.3,39.9 0,39.9 8.3,19.9 " />
	<polygon
		class="pattern_st1"
		points="147.3,39.9 147.3,59.8 104.1,59.8 112.4,39.9 "
	/>
	<polygon class="pattern_st0" points="54.3,19.9 51,19.9 59.3,0 62.6,0 54.3,19.9 " />
	<polygon
		class="pattern_st0"
		points="48.4,19.9 45.1,19.9 53.4,0 56.7,0 48.4,19.9 "
	/>
</svg>
